import { render, staticRenderFns } from "./CanvasSnow.vue?vue&type=template&id=50cf63b8&scoped=true&"
import script from "./CanvasSnow.vue?vue&type=script&lang=js&"
export * from "./CanvasSnow.vue?vue&type=script&lang=js&"
import style0 from "./CanvasSnow.vue?vue&type=style&index=0&id=50cf63b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf63b8",
  null
  
)

component.options.__file = "CanvasSnow.vue"
export default component.exports